
import { ReactNode } from 'react';

interface ButtonProps {
  children: ReactNode;
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
  href?: string;
}

export default function Button({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '',
  ...props 
}: ButtonProps) {
  const baseStyles = 'font-medium transition-all duration-300 rounded-md whitespace-nowrap cursor-pointer';
  
  const variants = {
    primary: 'bg-[#D4C5A9] text-[#0B1B3A] hover:bg-[#E8DCC4]',
    secondary: 'bg-[#162D52] text-[#F5F0E8] hover:bg-[#1E3A66]',
    outline: 'border-2 border-[#D4C5A9] text-[#D4C5A9] hover:bg-[#D4C5A9] hover:text-[#0B1B3A]',
  };

  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
